module.exports = __webpack_public_path__ + "static/media/title.696199f0.png";